const isAdminOrOwnerInGroup = ({ claims, groupId }) => {
    if (claims && claims.groups) {
        const groupRoles = claims.groups[groupId];
        return Array.isArray(groupRoles) && (groupRoles.indexOf('administrator') !== -1 || groupRoles.indexOf('owner') !== -1);
    }
    return false;
};

export default isAdminOrOwnerInGroup;
